import { Box, Typography, useTheme } from "@mui/material";
import { useAppSelector } from "../../../hooks/useRedux";
import UnauthorizedSVG from "../../../media/images/icons/unauthorizedSVG";
import AuthorizedSVG from "../../../media/images/icons/authorizedSVG";

export default function AuthorizationOwnerLabel() {
  const isConfirm = useAppSelector((state) => state.owner.isConfirm);
  const theme = useTheme();

  return (
    <>
      {!isConfirm ? (
        <Box
          sx={{
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.palette.secondary[50],
            borderRadius: "4px",
            paddingY: "2px",
            paddingX: "4px",
            gap: "3px",
          }}
        >
          <UnauthorizedSVG size={18} />
          <Typography noWrap sx={{ color: "secondary.main", fontSize: "10px" }}>
            نیازمند احراز هویت
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.palette.success.light,
            borderRadius: "4px",
            paddingX: "4px",
            gap: "3px",
          }}
        >
          <AuthorizedSVG size={18} />
          <Typography noWrap sx={{ color: "success.main", fontSize: "10px" }}>
            کاربر احراز هویت شده
          </Typography>
        </Box>
      )}
    </>
  );
}
